import React, { useEffect } from 'react';
import styled from 'styled-components';
import { LipscoreRatingInterface } from './types/LipscoreProductModel.types';
import {
    REVIEWS_TAB,
} from '../ProductPageTabs/ProductTabsConstants';

const StyledLipscoreRating = styled.div`
  font-size: 1rem;
`;

const LipscoreRating = ({ productModel, setActiveTab, readOnly }: LipscoreRatingInterface) => {
    useEffect(() => {
        globalThis.lipscore && globalThis.lipscore.reInitWidgets();

        function lipscoreReviewStopFunction() {
            clearInterval(lipscoreReviewInterval);
        }

        function lipscoreReviewTimer() {
            var lipscoreLink = document.getElementsByClassName("lipscore-rating-review-link");
            if (setActiveTab && lipscoreLink && lipscoreLink.length > 0) {
                var link = lipscoreLink[0];

                if (link) {
                    link.addEventListener("click", function (e) {
                        e.preventDefault();

                        setActiveTab(REVIEWS_TAB)

                        var lipscoreReviews = document.getElementsByClassName("lipscore-rating-small");
                        if (lipscoreReviews && lipscoreReviews.length > 0) {
                            var reviews = lipscoreReviews[0];
                            if (reviews) {
                                reviews.scrollIntoView({ behavior: 'smooth' });
                            }
                        }

                    });
                    lipscoreReviewStopFunction();
                }
            }
        }

        const lipscoreReviewInterval = setInterval(lipscoreReviewTimer, 1000);
    }, [setActiveTab]);



    return (
        <StyledLipscoreRating>
            <div className='lipscore-rating-small'
                data-ls-product-id={productModel.productId}
                data-ls-product-name={productModel.name}
                data-ls-product-brand={productModel.brand}
                data-ls-product-url={productModel.productUrl}
                data-ls-product-image={productModel.imageUrl}
                data-ls-product-description={productModel.description}
                data-ls-product-price={productModel.price}
                data-ls-product-currency={productModel.currency}
                data-ls-product-availability={productModel.inStock}
                data-ls-product-category={productModel.category}
                data-ls-product-gtin={productModel.gtin}
                data-ls-readonly={readOnly ? 'true' : 'false'}></div>
        </StyledLipscoreRating>
    );
};

export default LipscoreRating;
